import React, { useEffect } from 'react'
import { ButtonCmp, InputCmp, DropDownCmp, WhiteButtonCmp } from '..'
import { useForm } from 'react-hook-form'
import styles from './ProfileForms.module.css'
import { Typography, InputAdornment } from '@mui/material'
import { UpdateProfileAction } from '../../Store/Actions/ProfileAction'
import { useDispatch, useSelector } from 'react-redux'
import { GetCitiesAction, GetStateAction } from '../../Store/Actions/GetActions'
import useAlert from '../../Hooks/useAlert/useAlert'
import { yupResolver } from '@hookform/resolvers/yup'
import { validation } from '../../Config'
import { removeHttps } from '../../Utils/utils'

function formatPhoneNumber(value) {
    const digits = value.replace(/\D/g, '')
    if (digits.length <= 3) return digits
    if (digits.length <= 6) return digits.slice(0, 3) + ' ' + digits.slice(3)
    return (
        digits.slice(0, 3) +
        ' ' +
        digits.slice(3, 6) +
        ' ' +
        digits.slice(6, 10)
    )
}

const ProfileInformationForm = ({ handleCancel, profileDetailsdata }) => {
    const {
        first_name,
        last_name,
        email,
        phone,
        street_address,
        company_name,
        state_id,
        city_id,
        city,
        state,
        zip,
        website,
        year_est,
        company_email,
    } = profileDetailsdata
    const { setAlert } = useAlert()
    const dispatch = useDispatch()
    const { statesdata } = useSelector((state) => state.StatesReducers)
    const { citiesdata } = useSelector((state) => state.CitiesReducers)

    const profileValidation = validation.profileValidation
    const { control, handleSubmit, watch } = useForm({
        mode: 'onChange',
        defaultValues: {
            contactFirstName: first_name || '',
            contactLastName: last_name || '',
            companyName: company_name || '',
            companyStreetAddress: street_address || '',
            companyCity: city || '',
            companyState: state || '',
            companyZip: zip || '',
            yearEst: year_est || '',
            companyPhone: phone || '',
            companyEmailAddress: company_email || '',
            website: removeHttps(website) || '',
        },
        resolver: yupResolver(profileValidation),
    })

    ///form state
    const stateState = watch('companyState', false)

    const onSubmit = (obj) => {
        dispatch(UpdateProfileAction(obj, 'profileInformation', setAlert))
    }

    useEffect(() => {
        dispatch(GetStateAction())
    }, [])

    useEffect(() => {
        if (stateState) {
            dispatch(GetCitiesAction(stateState.label))
        }
    }, [stateState])

    return (
        <section className={styles.profile_information}>
            <div className={styles.profile_information_heading}>
                <Typography noWrap variant="h5" fontWeight={'bold'}>
                    Profile Information
                </Typography>
            </div>
            <div className={styles.detailsBoxes}>
                <section>
                    <Typography
                        fontSize="16px"
                        sx={{ color: 'var(--black)', fontWeight: 'bold' }}
                    >
                        Account Email *
                    </Typography>
                    <Typography
                        fontSize="18px"
                        sx={{ mt: '10px', color: 'var(--primary-color)' }}
                    >
                        {email}
                    </Typography>
                </section>
            </div>
            <div className={styles.detailsBoxes}>
                <section>
                    <InputCmp
                        name="contactFirstName" //imporant
                        control={control} //imporant
                        label="Contact First Name"
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="contactLastName" //imporant
                        control={control} //imporant
                        label="Contact Last Name"
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="companyName" //imporant
                        control={control} //imporant
                        label="Company Name"
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="companyStreetAddress" //imporant
                        control={control} //imporant
                        label="Company Street Address"
                        required
                    />
                </section>
            </div>
            <div className={styles.detailsBoxes}>
                <section>
                    <DropDownCmp
                        name="companyState" //imporant
                        control={control} //imporant
                        label="Company State"
                        options={statesdata}
                        disableClearable
                        freeSolo={false}
                        required
                    />
                </section>
                <section>
                    <DropDownCmp
                        name="companyCity" //imporant
                        control={control} //imporant
                        label="Company City"
                        options={citiesdata}
                        disableClearable
                        freeSolo={false}
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="companyZip" //imporant
                        control={control} //imporant
                        label="Company Zip"
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="yearEst" //imporant
                        control={control} //imporant
                        label="Year Est."
                        required
                    />
                </section>
            </div>
            <div className={styles.detailsBoxes}>
                <section>
                    <InputCmp
                        name="companyPhone"
                        control={control}
                        label="Company Phone"
                        required
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    +1
                                </InputAdornment>
                            ),
                        }}
                        formatValue={formatPhoneNumber}
                    />
                </section>
                <section>
                    <InputCmp
                        name="companyEmailAddress" //imporant
                        control={control} //imporant
                        label="Company Email Address"
                        required
                    />
                </section>
                <section>
                    <InputCmp
                        name="website" //imporant
                        control={control} //imporant
                        label="Website"
                        type={'text'}
                        prefix="https://"
                        rules={{
                            required: 'Website is required',
                            pattern: {
                                value: /^(https?:\/\/)?([\w-]+\.)+[\w-]{2,}(\/[\w-]*)*\/?$/,
                                message: 'Please enter a valid domain',
                            },
                        }}
                        placeholder={'www.yourwebsite.com'}
                    />
                </section>
                <section></section>
            </div>
            <div className={styles.buttonContainer}>
                {/* <section> */}

                <WhiteButtonCmp
                    title="Cancel"
                    onClick={() => handleCancel('profileInfo')}
                />
                {/* </section>
                <section> */}
                <ButtonCmp
                    title="Save"
                    style={{ marginLeft: '10px' }}
                    onClick={handleSubmit(onSubmit)}
                />
                {/* </section> */}
            </div>
        </section>
    )
}

export default ProfileInformationForm
